import { getMessage } from 'util/locale';
import { CropFromOL } from 'store/types/types';

export function parseOLCropList(OLResponse: CropFromOL) {
  const crops = {};
  OLResponse.crops.nodes.forEach((item) => {
    const sproutId = item.id;
    const legacyId = parseInt(item.cropLegacyIds.id, 10);
    const code = item.cropLegacyIds.cropCode;

    const crop = {
      'nominal-weight': item.nominalWeight
        ? { q: item.nominalWeight.value, u: item.nominalWeight.unit }
        : null,
      'legacy-id': legacyId,
      code,
      'dfp-uuid': sproutId,
      name: getMessage(`crop--${item.cropLegacyIds.cropCode}`) || item.name,
    };

    crops[sproutId] = { ...crop, id: sproutId};
    crops[legacyId] = { ...crop, id: legacyId};
    crops[code] = { ...crop, id: code};
  });

  return crops;
};
